<script setup>
import { ref, onMounted } from "vue";
import { defineProps } from "vue";
import { useSlopeStore } from "~/stores/smc/slopeStore";

const slopeStore = useSlopeStore();
const selectedSlopeId = ref(null);

// Props
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  level: {
    type: Number,
    default: 0,
  },
});

const relativeURL = ref("");


onMounted(() => {
  try {
    relativeURL.value = import.meta.env.BASE_URL || "";
  } catch (error) {
    console.error("Error fetching base URL:", error);
  }
  slopeStore.fetchSlopesAll({ page: 1, limit: 100 });
});
function handleSlopeSelect(slope) {
  selectedSlopeId.value = slope.id;
  slopeStore.fetchSlope(slope.id);
  navigateTo(`/slope/${slope.id}`);
}
</script>

<template>
  <v-list-group v-if="item.title == 'Site'" 
    prepend-icon="mdi-slope-downhill">
    <template v-slot:activator="{ props }">
      <v-list-item v-bind="props" title="Site Select" :active-class="item.isCustom ? item.customActiveTab : undefined" />
    </template>
    <v-list-item v-for="slope in slopeStore.getSlopes" :key="slope.id" :title="slope.name"
      :active="selectedSlopeId === slope.id"  :active-class="item.isCustom ? item.customActiveTab : undefined"
      @click="handleSlopeSelect(slope)" />
  </v-list-group>

  
  <v-list-item v-else :to="item.getURL && item.type !== 'external' ? `${relativeURL}${item.to}` : item.to"
    :href="item.type === 'external' ? item.to : ''" rounded :disabled="item.disabled"
    :target="item.type === 'external' ? '_blank' : ''" class="py-5"
    :active-class="item.isCustom ? item.customActiveTab : undefined">





    <template v-slot:prepend>
      <v-icon v-if="item.icon && item.title != 'Site'">{{ item.icon }}</v-icon>
    </template>


    <v-list-item-title v-if="item.title != 'Site'">{{ item.title }}</v-list-item-title>

    <v-list-item-subtitle v-if="item.subCaption" class="text-caption mt-0 hide-menu">
      {{ item.subCaption }}
    </v-list-item-subtitle>

    <template v-slot:append v-if="item.chip">
      <v-chip :color="item.chipColor" class="sidebarchip hide-menu" size="small" :variant="item.chipVariant"
        :prepend-icon="item.chipIcon">
        {{ item.chip }}
      </v-chip>
    </template>
  </v-list-item>
</template>

 
<style>
.custom-active-smc {
  /* background-color: #EA2628 !important;
  color: white !important; */
   color: #EA2628 !important;
  background-color: white !important;
}
.custom-active-slope{
  color: #EA2628 !important;
  background-color: white !important;
}
</style>
